import store from "@/store/index";
import router from "@/router";
import ModalAlert from "@/components/common/ModalAlert";
import { createApp } from 'vue';
import { refresh } from "@/api/auth";

let isTokenRefreshing = false;
let refreshSubscribers = [];
let modalInstance = null;

// 리프레시 후, 대기 중인 요청을 재시도하기 위한 콜백 실행
const onTokenRefreshed = (newToken) => {
	refreshSubscribers.forEach((callback) => callback(newToken));
	refreshSubscribers = [];
};

// 토큰 갱신이 완료되면 재시도할 요청을 등록
const addRefreshSubscriber = (callback) => {
	refreshSubscribers.push(callback);
};

export function setInterceptors(instance) {
	instance.interceptors.request.use(
		(config) => {
			const ndbTkn = store.getters["userStore/getNdbTkn"];
			if (ndbTkn) {
				config.headers.Authorization = `Bearer ${ndbTkn}`;
			}
			return config;
		},
		(error) => Promise.reject(error)
	);

	instance.interceptors.response.use(
		(response) => response,
		async (error) => {
			const { config, response } = error;
			if (!response) return Promise.reject(error); // 네트워크 오류 대비

			const originalRequest = config;
			const { status, data } = response;

			// AccessToken 만료 (A003)
			if (status === 401 && data.code === "A003") {
				return new Promise((resolve, reject) => {
					// 실패한 요청을 큐에 저장 (첫 번째 요청도 포함)
					addRefreshSubscriber((newToken) => {
						originalRequest.headers.Authorization = `Bearer ${newToken}`;
						resolve(instance(originalRequest));
					});

					// 토큰 갱신 진행중이 아니면 갱신 시작
					if (!isTokenRefreshing) {
						isTokenRefreshing = true;
						const orginTkn = store.getters["userStore/getNdbTkn"];
						const param = { ndbTkn: orginTkn };
						refresh(param)
							.then((renewToken) => {
								store.dispatch("userStore/REFRESH_USER", renewToken.data);
								onTokenRefreshed(renewToken.data.token); // 큐에 있는 요청들 재시도
							})
							.catch((refreshError) => {
								refreshSubscribers = []; // 큐 초기화
								store.dispatch("userStore/LOGOUT");
								router.push({ name: 'Login', query: { redirect: encodeURIComponent(router.currentRoute.value.fullPath) } });
								showModal(data.message);
								reject(refreshError);
							})
							.finally(() => {
								isTokenRefreshing = false;
							});
					}
				});
			}
			// RefreshToken 만료 (A004)
			else if (status === 401 && data.code === "A004") {
				store.dispatch("userStore/LOGOUT");
				router.push({ name: 'Login', query: { redirect: encodeURIComponent(router.currentRoute.value.fullPath) } });
				showModal(data.message);
			}

			return Promise.reject(error);
		}
	);

	function showModal(message) {
		if (!modalInstance) {
			const div = document.createElement("div");
			document.body.appendChild(div);
			const appInstance = createApp(ModalAlert);
			modalInstance = appInstance.mount(div);
			modalInstance.show({
				title: "알림",
				content: message,
			}).then(() => {
				modalInstance = null;  // Reset modal instance
			});
		} else {
			modalInstance.show({
				title: "알림",
				content: message,
			});
		}
	}

	return instance;
}

export function setInterceptorsWithReauth(instance) {
  	setInterceptors(instance);

	instance.interceptors.request.use(
		(config) => {
		const reauthToken = store.state.userStore.reauthToken; 
		if (reauthToken) {
			config.headers["X-Reauth-Token"] = reauthToken;
		}
		return config;
		},
		(error) => Promise.reject(error)
	);

	instance.interceptors.response.use(
		(response) => response,
		async (error) => {
			const { response } = error;
			if (!response) return Promise.reject(error);

			const { status, data } = response;

			if (status === 403) {
			store.dispatch("userStore/CLEAR_REAUTH");
			router.push({
				name: "MypageUsage",
				query: { redirect: encodeURIComponent(router.currentRoute.value.fullPath) },
			});
			showModal(data?.message);
			}

			return Promise.reject(error);
		}
	);

	function showModal(message) {
		if (!modalInstance) {
			const div = document.createElement("div");
			document.body.appendChild(div);
			const appInstance = createApp(ModalAlert);
			modalInstance = appInstance.mount(div);
			modalInstance.show({
				title: "알림",
				content: message,
			}).then(() => {
				modalInstance = null;  // Reset modal instance
			});
		} else {
			modalInstance.show({
				title: "알림",
				content: message,
			});
		}
	}

  return instance;
}